import type { RiskLevel } from '@/api/types'
import { riskLabel } from '@/i18n/labels'
import { Chip } from './Chip'
import { cn } from './cn'

const tone: Record<RiskLevel, { cls: string; dot: string }> = {
  GREEN: { cls: 'bg-green-50 text-green-800', dot: '#1f9d55' },
  YELLOW: { cls: 'bg-amber-50 text-amber-800', dot: '#d9a400' },
  ORANGE: { cls: 'bg-orange-50 text-orange-800', dot: '#e8730c' },
  RED: { cls: 'bg-red-50 text-red-800', dot: '#d64545' },
}

/** Risk colour code — the single visual language of risk across the app. */
export function RiskChip({ level }: { level: RiskLevel }) {
  const t = tone[level]
  return (
    <Chip className={cn(t.cls)} dot={t.dot}>
      {riskLabel[level]}
    </Chip>
  )
}
